import { searchBox, hits, refinementList } from 'instantsearch.js/es/widgets';

import GlobalSearch from './global-search';
import { createDropdown } from './vendor/dropdown';

const excludeFromSearch = {
  news_type: ['Award', 'Press'],
};

/**
 * NewsSearch
 */
class NewsSearch extends GlobalSearch {
  constructor(rootEl) {
    super(rootEl);

    this.resultsLabel = {
      singular: 'article',
      plural: 'articles',
    };
  }

  /**
   * Convert a string to a safe HTML free string with decoded entities.
   *
   * @param {String} html
   * @returns {String}
   */
  decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  /**
   * Initialize the search
   *
   * @override GlobalSearch
   */
  init() {
    this.configureWidgets();
    this.configureNewsTypeRefinementDropdown();
    this.setWidgets();
    this.setNewsWidgets();
    this.addWidgets();

    const filters = [];

    for (const [key, values] of Object.entries(excludeFromSearch)) {
      values.forEach(value => {
        filters.push(`NOT ${key}:${value}`);
      });
    }

    this.searchParams.filters = filters.join(' AND ');

    this.search.start();

    this.scrollToSearch();
  }

  /**
   * Scroll to the search results if the search query is present
   */
  scrollToSearch() {
    const searchParams = window.location.search;

    if (searchParams.includes(this.indexName)) {
      this.rootEl.scrollIntoView();
    }
  }

  /**
   * Configure news-specific widgets
   */
  setNewsWidgets() {
    this.widgets.push(this.newsTypeRefinementDropdown);
  }

  /**
   * Configure the search box
   *
   * @override GlobalSearch
   */
  configureSearchBox() {
    this.searchBox = searchBox({
      container: '.js-news-search-input',
      placeholder: 'Search by name',
      showSubmit: false,
    });
  }

  /**
   * Configure the news type refinement dropdown
   */
  configureNewsTypeRefinementDropdown() {
    if (!document.querySelector('.js-search-news-type-input')) {
      return;
    }

    const newsTypeDropdown = createDropdown(refinementList, {
      cssClasses: { root: 'ais-Dropdown-news-type' },
      buttonText: 'All Content',
    });

    this.newsTypeRefinementDropdown = newsTypeDropdown({
      container: '.js-search-news-type-input',
      attribute: 'news_type',
      limit: 10,
      showMore: true,
      showMoreLimit: 100,
      sortBy: ['name:asc'],
    });
  }

  /**
   * Configure the results list
   */
  configureResultsList() {
    this.resultsList = hits({
      container: '.js-search-hits',
      templates: {
        /* eslint-disable */
        item: (hit, { html }) => {
          const { description, link, title, thumbnail } = hit;
          return html` <div class="hit ${thumbnail && thumbnail.src ? 'hit--has-image' : ''}">
            ${thumbnail && thumbnail.src
              ? html` <div class="hit__art has__art-link">
                  <figure class="hit__figure">
                    <img src="${thumbnail.src}" alt="${thumbnail.alt}" class="hit__img" />
                  </figure>
                  <a class="hit__link" href="${link}" tabindex="-1" aria-hidden="true"></a>
                </div>`
              : ''}
            <div class="hit__text">
              <h3 class="hit__name">
                <a class="hit__link" href="${link}">${title}</a>
              </h3>
              <p class="hit__excerpt">${this.decodeHtml(description)}</p>
            </div>
            <div class="hit__button">
              <a class="hit__button-link" href="${link}" tabindex="-1" aria-hidden="true"
                >View article</a
              >
            </div>
          </div>`;
        },
        /* eslint-enable */
      },
    });
  }
}

export default NewsSearch;
